/**
 * FloorBreachDialog.jsx (iter142 refactor — extracted from CustomerPricing.jsx)
 *
 * Confirmation dialog shown when PUT /api/customer-pricing/override returns
 * 422 with detail.code='margin_floor_breached'. Parent passes the structured
 * breach payload + an onForce callback that re-saves with force=true.
 */
import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../ui/dialog';
import { Warning } from '@phosphor-icons/react';

const fmtMoney = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  try {
    return Number(n).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch {
    return `$${Number(n).toFixed(2)}`;
  }
};

export const FloorBreachDialog = ({ breach, onCancel, onForce, busy }) => (
  <Dialog open={!!breach} onOpenChange={(v) => { if (!v) onCancel(); }}>
    <DialogContent className="border border-rose-300 rounded-none" data-testid="floor-breach-dialog">
      <DialogHeader>
        <DialogTitle className="font-mono flex items-center gap-2 text-rose-700">
          <Warning size={18} weight="fill" /> Margin floor breached
        </DialogTitle>
        <DialogDescription className="text-xs">
          The override you tried to save would drop the SKU&apos;s margin below the configured floor for this tenant.
        </DialogDescription>
      </DialogHeader>
      {breach && (
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">{breach.message}</p>
          <div className="bg-rose-50 border border-rose-200 px-3 py-2 text-xs space-y-1">
            <div className="flex justify-between"><span className="text-muted-foreground">Proposed price</span><span className="font-mono font-bold">{fmtMoney(breach.proposed_price)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Landed cost</span><span className="font-mono">{fmtMoney(breach.landed_cost)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Resulting margin</span><span className="font-mono font-bold text-rose-700">{breach.proposed_margin_pct}%</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Configured floor</span><span className="font-mono">{breach.min_margin_pct}%</span></div>
          </div>
          <p className="text-[11px] text-amber-700 italic">
            Your tenant is in <b>block</b> mode. Choose <b>Override anyway</b> to bypass the floor for this one save, or switch to <b>warn</b> mode in tier config to allow without confirmation.
          </p>
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={onCancel}
              disabled={busy}
              className="rounded-none"
              data-testid="floor-breach-cancel-btn"
            >Cancel</Button>
            <Button
              onClick={onForce}
              disabled={busy}
              className="bg-rose-600 hover:bg-rose-700 text-white rounded-none"
              data-testid="floor-breach-force-btn"
            >{busy ? 'Saving…' : 'Override anyway'}</Button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
